import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  logLevel: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.OFF,

    /*apiUrl: 'https://api-carsmanagement.easy-solution.fr/api', //PROD LWS
    environment: 'PROD',*/

    apiUrl: 'https://preprod-api-carsmanagement.easy-solution.fr/api', //PREPROD LWS
    environment : 'PREPROD',

    
    imagesUrl: 'https://images-bmc-auto.easy-solution.fr',
    apiKey: 'XkTJj6dRGpMMg5YQ836VNAzy0iA4n4H1aYf5wR0yR7EG2zIFhXizqEiMc7nv74CFVIJMgQK4MRRLD0u1zZt5yAxJjLvgdonzJ4aSs85ZEZuYLlvvKvlErG0RHuhugEvr',
    clientID: 'BMCAUTO',
    website: 'https://bmc-auto.fr'

    /*imagesUrl: 'https://images-cannes-automobile.easy-solution.fr',
    apiKey: 'DCbdiqSDVsuvisv15vsvdv564dvVDS4V5654svdv454sdv54vv4ddsDS9895DFSvds',
    clientID: 'CANNESAUTO',
    website: 'https://cannes-automobile.fr'*/
};
